import React from "react";
// react component for creating beautiful carousel
import Carousel from "react-slick";
// @material-ui/core components
import withStyles from "@material-ui/core/styles/withStyles";
import artistStyles from "views/Artists/Styles/ArtistStyles.jsx";

// @material-ui/icons
//import LocationOn from "@material-ui/icons/LocationOn";
// core components
import GridContainer from "components/Grid/GridContainer.jsx";
import GridItem from "components/Grid/GridItem.jsx";
import Card from "components/Card/Card.jsx";
import carouselStyle from "assets/jss/material-kit-react/views/componentsSections/carouselStyle.jsx";
import cottonwoods from "assets/img/Eide/Arizona Cottonwoods.jpg";
import blueSky from "assets/img/Eide/BlueSkyLandscape.JPG";
import birchs from "assets/img/Eide/Birchs in winter.jpg";
import fourLargePears from "assets/img/Eide/FourLargePears.jpg";
import blonde from "assets/img/Eide/BlondWomanSmall.jpg";
import applesTable from "assets/img/Eide/eideapplestable.jpg";
import homeMarket from "assets/img/Eide/HomeMarket.jpg";
import boyDog from "assets/img/Eide/BoyDog.jpg";
import desertLandscape from "assets/img/Eide/DesertLandscape.jpg";
import eightApples from "assets/img/Eide/EightApples.jpg";
import fivePeaches from "assets/img/Eide/FivePeaches.jpg";
import peachesAndMarigolds from "assets/img/Eide/PeachesAndMarigolds.jpg";
import diane from "assets/img/Eide/Diane.jpg";



class SectionCarousel extends React.Component {
  render() {
    const { classes } = this.props;
    const settings = {
      dots: true,
      infinite: true,
      speed: 500,
      slidesToShow: 1,
      slidesToScroll: 1,
      autoplay: false
    };
    return (
      <div className={classes.section}>
        <div className={classes.container}>
          <GridContainer>
            <GridItem xs={12} sm={12} md={8} className={classes.marginAuto}>
              <Card carousel>
                <Carousel {...settings}>
                  <div>
                    <img
                      src={cottonwoods}
                      alt="Arizona Cottonwoods"
                      className="slick-image"
                    />
                  </div>
                  <div>
                    <img
                      src={blueSky}
                      alt= "Blue Sky Landscape"
                      className="slick-image"

                    />
                  </div>
                  <div>
                    <img
                      src={birchs}
                      alt="Birch's in Winter"
                      className="slick-image"
                    />
                  </div>
                  <div>
                    <img
                      src={fourLargePears}
                      alt="Four Large Pears"
                      className="slick-image"
                    />
                  </div>
                  <div>
                    <img
                      src={blonde}
                      alt="Blonde Woman"
                      className="slick-image"
                    />
                  </div>
                  <div>
                    <img
                      src={applesTable}
                      alt="Apples Table"
                      className="slick-image"
                    />
                  </div>
                  <div>
                    <img
                      src={homeMarket}
                      alt="Home Market"
                      className="slick-image"
                    />
                  </div>
                  <div>
                    <img
                      src={boyDog}
                      alt="Boy and Dog"
                      className="slick-image"
                    />
                  </div>
                  <div>
                    <img
                      src={desertLandscape}
                      alt="Desert Lands"
                      className="slick-image"
                    />
                  </div>
                  <div>
                    <img
                      src={eightApples}
                      alt="Eight Apples"
                      className="slick-image"
                    />
                  </div>
                  <div>
                    <img
                      src={fivePeaches}
                      alt="Five Peaches"
                      className="slick-image"
                    />
                  </div>
                  <div>
                    <img
                      src={peachesAndMarigolds}
                      alt="Peaches and Marigold"
                      className="slick-image"
                    />
                  </div>
                  <div>
                    <img
                      src={diane}
                      alt="Diane Eide"
                      className="slick-image"
                      //className={artistStyles.imgCarousel}
                    />
                  </div>
                </Carousel>
              </Card>
            </GridItem>
          </GridContainer>
        </div>
      </div>
    );
  }
}

export default withStyles(carouselStyle)(SectionCarousel);



// WEBPACK FOOTER //
// ./src/views/Artists/Sections/DianeEideCarousel.jsx